import axiosService from 'services/axios.service';

const API_URL = process.env.REACT_APP_URL_API;

const BASE_API_URL = `${API_URL}/v1/admin`;

export const getTrackDlPurchase = async (id: any, payload: any): Promise<any> => {
    const response = await axiosService.post(`${BASE_API_URL}/track-purchases/track-dl/${id}`, payload);
    return response?.data;
};
